/* eslint-disable no-shadow */

export type TAppState = {
  filters: TFilters;
  setFilters: (filters: TFilters) => void;
  sorts: ESort;
  setSortOptions: (sorts: ESort) => void;
  chosens: TChosen;
  setChosenToy: (chosens: TChosen) => void;
  settings: TSettings;
  setSettings: (settings: TSettings) => void;
  toysOnTree: TDragedToy[];
  setToysOnTree: (toysOnTree: TDragedToy[]) => void;
  garlandSettings: TGarland;
  setGarland: (garlandSettings: TGarland) => void;
};

export enum ESort {
  nameAlphaDown = 'Alphabet-up-down',
  nameAlphaUp = 'Alphabet-down-up',
  yearDateIncrease = 'Purchase-data-increase',
  yearDateDecrease = 'Purchase-data-decrease',
}
export const InitialChosen: TChosen = [];

export const InitialSortOption = ESort.nameAlphaDown;

export const InitialFilters: TFilters = {
  minCopiesCount: 1,
  maxCopiesCount: 12,
  minCopiesYear: 1940,
  maxCopiesYear: 2020,
  size: { big: false, average: false, small: false },
  shape: {
    ball: false,
    bell: false,
    cone: false,
    snowflake: false,
    toy: false,
  },
  color: { white: false, yellow: false, red: false, blue: false, green: false },
  favorite: false,
  search: '',
};

export const InitialSettings: TSettings = {
  background: 1,
  tree: 1,
  snow: false,
};

export const InitialGarland: TGarland = {
  garland: false,
  colorGarland: 'multicolor',
};

export type TChosen = string[];

export type TFilters = {
  minCopiesCount: number;
  maxCopiesCount: number;
  minCopiesYear: number;
  maxCopiesYear: number;
  size: { big: boolean; average: boolean; small: boolean };
  shape: {
    ball: boolean;
    bell: boolean;
    cone: boolean;
    snowflake: boolean;
    toy: boolean;
  };
  color: {
    white: boolean;
    yellow: boolean;
    red: boolean;
    blue: boolean;
    green: boolean;
  };
  favorite: boolean;
  search: string;
};

export type TSettings = {
  background: number;
  tree: number;
  snow: boolean;
};

export type TDragedToy = {
  id: string;
  x: number;
  y: number;
  index: string;
};

export type TGarland = {
  garland: boolean;
  colorGarland: string;
};
